import { env } from '@/env'

import { attachAuthInterceptor } from './interceptors/auth'
import { attachRecoveryInterceptor } from './interceptors/recovery'
import { createApiClient, publicApi, publicApiWithoutAuth, selfApi } from './clients'

export { createApiClient, publicApi, publicApiWithoutAuth, selfApi } from './clients'

const api = createApiClient({
  baseURL: env.NEXT_PUBLIC_EVNTTZ_BACKEND_API_BASE_URL,
  headers: { accept: 'application/json' }
})

attachAuthInterceptor(api)
attachRecoveryInterceptor(api)

export { api }
